import styled from "styled-components"

import { internalLink } from "~/services/helper"
import LogoConsultation from "~/svgs/logo_consultation.svg"
import LogoCourses from "~/svgs/logo_courses.svg"
import LogoEvents from "~/svgs/logo_events.svg"
import LogoIntern from "~/svgs/logo_intern.svg"
import LogoNewGradJobs from "~/svgs/logo_new-grad-jobs.svg"
import LogoNewGradScout from "~/svgs/logo_new-grad-scout.svg"
import LogoPlain from "~/svgs/logo_plain.svg"

interface Props {
  type: keyof typeof LogoType
  width?: number
  height?: number
  className?: string
}

interface StyledProps {
  width?: number
  height?: number
}

const Logo = ({ type, width, height, className }: Props) => {
  return (
    <Wrapper width={width} height={height} className={className}>
      {LogoTag[type]}
    </Wrapper>
  )
}

export const LogoType = {
  Plain: "LogoPlain",
  Intern: "LogoIntern",
  NewGradJobs: "LogoNewGradJobs",
  NewGradScout: "LogoNewGradScout",
  Consultation: "LogoConsultation",
  Courses: "LogoCourses",
  Events: "LogoEvents",
  ShortIntern: "LogoShortIntern",
}

export const LogoURL = {
  Plain: `${process.env.INFRA_INTERN_URL}/long-internship`,
  Intern: `${process.env.INFRA_INTERN_URL}/long-internship`,
  NewGradJobs: `${internalLink("/new-grad-jobs")}`,
  NewGradScout: `${internalLink("/new-grad-scout")}`,
  Consultation: `${internalLink("/new-grad-jobs/consultation")}`,
  Courses: `${internalLink("/courses")}`,
  Events: `${internalLink("/events")}`,
  ShortIntern: `${internalLink("/short-internships")}`,
}

const LogoTag = {
  Plain: <LogoPlain />,
  Intern: <LogoIntern />,
  NewGradJobs: <LogoNewGradJobs />,
  NewGradScout: <LogoNewGradScout />,
  Consultation: <LogoConsultation />,
  Courses: <LogoCourses />,
  Events: <LogoEvents />,
  ShortIntern: <LogoIntern />,
}

const Wrapper = styled.div`
  svg {
    width: ${({ width }: StyledProps) => (width ? `${width}px` : "auto")};
    height: ${({ height }: StyledProps) => (height ? `${height}px` : "auto")};
  }
`

export default Logo
